export const screeningUploadFileRights = [
    "wangruoxi@ust.hk",
    "enasn@ust.hk",
    "enasn@hkust-gz.edu.cn",
    "jessicatai@ust.hk"
]
